// extracted by mini-css-extract-plugin
export default {"deviceButton":"ToggleParticipantsButton_deviceButton__XRUkJ","icon":"ToggleParticipantsButton_icon__R1-dc","badge":"ToggleParticipantsButton_badge__7c2Mi"};